import { createContext, useContext } from 'react';

import type { IContentKey } from '../interfaces';

export const contentsContext = createContext<Record<string, string>>({});

export const ContentsProvider = contentsContext.Provider;

export const GetContent = (key: IContentKey): string => {
  const contents = useContext(contentsContext);

  return contents[key.id] ?? '';
};
